import { createSlice } from '@reduxjs/toolkit'

const reducerName = 'auth'

const initialState = {
  status: false,
  data: null,
  errorStatus: null,
}

const authSlice = createSlice({
  name: reducerName,
  initialState,
  reducers: {
    changeAuthStatus(state, action) {
      state.status = action.payload
    },

    setAuth(state, action) {
      state.status = action.payload.status
      state.data = action.payload.data
      state.errorStatus = null
    },

    setAuthError(state, action) {
      state.status = false
      state.data = null
      state.errorStatus = action.payload
    },

    clearAuth(state) {
      state.status = false
      state.data = null
      state.errorStatus = null
    },
  },
})

const { setAuth, setAuthError, clearAuth, changeAuthStatus } = authSlice.actions

export const actions = {
  setAuth,
  setAuthError,
  clearAuth,
  changeAuthStatus,
}

export const { reducer } = authSlice
